import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import TitleBar from 'components/TitleBar';
import faker from 'faker';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { getToken } from 'utils/apiCalls';
import Button from '@material-ui/core/Button';
import get from 'lodash/get';
import config from 'config';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  button: {
    marginRight: theme.spacing(2),
  },
  main: {
    marginTop: theme.spacing(5),
  },
  paper: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(3),
    textAlign: 'center',
  },
  links: {
    cursor: 'pointer',
  },
  linkContainer: {
    margin: '1em',
  },
}));

const { STAGE } = config;
export default function Home() {
  const classes = useStyles();
  const history = useHistory();
  let fakeSessionId;
  if (STAGE === 'confqa') {
    fakeSessionId = '63765ab3-2603-45e8-bbe8-6b1d98c933fd';
  } else if (process.env.REACT_APP_CONFTWO) {
    fakeSessionId = '63765ab3-2603-45e8-bbe8-6b1d98c933fz';
  } else if (STAGE === 'demo') {
    fakeSessionId = '63765ab3-2603-45e8-bbe8-6b1d98c933zz';
  } else {
    fakeSessionId = '69765ab3-2603-45e8-bbe8-6b1d98c933fe';
  }
  const extraSessions = {
    2: '63765ab3-2603-45e8-bbe8-6bzzzzc933fd',
    3: '63765ab3-2603-45e8-bbe8-6aaaazc933fd',
    4: '6376z8ui-2603-45e8-bbe8-6aaaazc933fd',
    5: '6376z8ui-9993-45e8-bbe8-6aaaazc933fd',
  };
  const showAdditionalSessions = STAGE === 'conference';
  const sessionNumbers = Object.keys(extraSessions).sort();

  const fakeSessionName = 'Marketing Summit Test';
  const createFakeConferenceToken = async (role, session = '1') => {
    fakeSessionId = get(extraSessions, session, fakeSessionId);
    const tokenData = await getToken(
      faker.name.firstName(),
      faker.name.lastName(),
      role,
      faker.internet.email(),
      fakeSessionId,
      fakeSessionName
    );

    history.push(`/conference/?token=${tokenData.data}`);
  };

  const createFakeSetupToken = async (role, session = 'one') => {
    fakeSessionId = get(extraSessions, session, fakeSessionId);
    const tokenData = await getToken(
      faker.name.firstName(),
      faker.name.lastName(),
      role,
      faker.internet.email(),
      fakeSessionId,
      fakeSessionName
    );

    history.push(`/conference-settings/?token=${tokenData.data}`);
  };

  const createFakeVodToken = async (role, session) => {
    fakeSessionId = get(extraSessions, session, fakeSessionId);
    const tokenData = await getToken(
      faker.name.firstName(),
      faker.name.lastName(),
      role,
      faker.internet.email(),
      fakeSessionId,
      fakeSessionName
    );

    history.push(`/vod?token=${tokenData.data}`);
  };

  return (
    <div className={classes.root}>
      <TitleBar />
      <Grid container>
        <Grid item xs={4} md={2} style={{ marginTop: '2em' }}>
          <Button variant="contained" onClick={() => createFakeSetupToken('admin')}>
            Conference Setup(Do this first for uninitialized meeting)
          </Button>
          {showAdditionalSessions && (
            <>
              {sessionNumbers.map((sessionNumber) => (
                <Button
                  key={sessionNumber}
                  variant="contained"
                  onClick={() => createFakeSetupToken('admin', sessionNumber)}
                >
                  {` Conference Setup Session ${sessionNumber}`}
                </Button>
              ))}
            </>
          )}
          <br />
          <br />
          <Button
            variant="contained"
            onClick={() => createFakeConferenceToken('attendee')}
            id="random-attendee"
          >
            Random attendee
          </Button>
          {showAdditionalSessions && (
            <>
              {sessionNumbers.map((sessionNumber) => (
                <Button
                  key={sessionNumber}
                  variant="contained"
                  onClick={() => createFakeConferenceToken('attendee', sessionNumber)}
                  id={`random-attendee-${sessionNumber}`}
                >
                  {`Random attendee Session ${sessionNumber}`}
                </Button>
              ))}
            </>
          )}
          <br />
          <br />

          <Button
            variant="contained"
            onClick={() => createFakeConferenceToken('presenter')}
            id="random-presenter"
          >
            Random presenter
          </Button>
          {showAdditionalSessions && (
            <>
              {sessionNumbers.map((sessionNumber) => (
                <Button
                  key={sessionNumber}
                  variant="contained"
                  onClick={() => createFakeConferenceToken('presenter', sessionNumber)}
                  id={`random-presenter-${sessionNumber}`}
                >
                  {`Random presenter Session ${sessionNumber}`}
                </Button>
              ))}
            </>
          )}

          <br />
          <br />
          <Button
            variant="contained"
            id="random-vod"
            onClick={() => createFakeVodToken('attendee')}
          >
            Test Vod
          </Button>
          {showAdditionalSessions && (
            <>
              {sessionNumbers.map((sessionNumber) => (
                <Button
                  key={sessionNumber}
                  variant="contained"
                  onClick={() => createFakeVodToken('attendee', sessionNumber)}
                  id={`random-vod-${sessionNumber}`}
                >
                  {`Test Vod ${sessionNumber}`}
                </Button>
              ))}
            </>
          )}

          {/* <Typography className={classes.linkContainer}>
            <Link className={classes.links} onClick={() => history.push(routes.CREATE_OR_JOIN)}>
              Create A Meeting
            </Link>
          </Typography>
          <Typography className={classes.linkContainer}>
            <Link className={classes.links} onClick={() => history.push(routes.CREATE_OR_JOIN)}>
              Join A Meeting
            </Link>
          </Typography>
          <Typography className={classes.linkContainer}>
            <Link className={classes.links} onClick={() => history.push(routes.KENDRA)}>
              Upload
            </Link>
          </Typography>
          <Typography className={classes.linkContainer}>
            <Link className={classes.links} onClick={() => history.push(routes.DEBUG)}>
              Testing
            </Link>
          </Typography>
          */}
          {/* <Typography className={classes.linkContainer}>
            <Link
              className={classes.links}
              onClick={() => history.push(routes.TEST_CONFERENCE_SETTINGS)}
            >
              Test Conference Setup
            </Link>
          </Typography>
          <Typography className={classes.linkContainer}>
            <Link
              className={classes.links}
              onClick={() => history.push(routes.TEST_CONFERENCE_PRESENTER)}
            >
              Test Conference as presenter
            </Link>
          </Typography>
          <Typography className={classes.linkContainer}>
            <Link
              className={classes.links}
              onClick={() => history.push(routes.TEST_CONFERENCE_ATTENDEE)}
            >
              Test conference as attendee
            </Link>
          </Typography>
          <Typography className={classes.linkContainer}>
            <Link className={classes.links} onClick={() => history.push(routes.ADMIN)}>
              Conference Administration
            </Link>
          </Typography> */}
        </Grid>
        {/* <Grid item xs={8}>
          <Search />
        </Grid> */}
      </Grid>
    </div>
  );
}
